import axios from "axios";
import env from "@/configuration/env";
import signedUrl from "@/utils/signedUrl";
import store from "@/store";

const instance = axios.create();

const useJson = config => {
  config.baseURL = env.api_base_address;
  config.headers.post["Content-Type"] = "application/json";
  config.headers.put["Content-Type"] = "application/json";
};

const useJwt = config => {
  var jwt = store && store.getters["cognito/accessToken"];
  if (jwt) {
    config.headers.common["Authorization"] = `Bearer ${jwt}`;
  }
};

const useSigned = config => {
  if (!signedUrl.isSignedUrl()) return;
  config.headers.common["X-APP-SIGNED-RESOURCE-TYPE"] = signedUrl.getResourceType();
  config.headers.common["X-APP-SIGNED-RESOURCE-ID"] = signedUrl.getResourceId();
  config.headers.common["X-APP-SIGNED-EXPIRATION"] = signedUrl.getExpiration();
  config.headers.common["X-APP-SIGNED-SIGNATURE"] = signedUrl.getSignature();
};

//request
instance.interceptors.request.use(config => {
  useJson(config);
  useJwt(config);
  useSigned(config);
  return config;
});

export default instance;
